// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsHoldingsCategorizeModule } from './app.module';
bootstrapAppModule(MutualFundsHoldingsCategorizeModule);
